export default defineAppConfig({
  ui: {
    colors: {
      primary: 'blue',
      neutral: 'slate'
    },
    pageSection: {
      slots: {
        container: 'flex flex-col lg:grid py-16 sm:py-18 lg:py-18 gap-8 sm:gap-16',
      },
    },
    pageHero: {
      slots: {
        title: 'text-6xl text-pretty tracking-tight font-bold text-highlighted md:text-5xl font-bold center',
        description: 'text-xl text-gray-600',
      },
    },
  }
})
